module.exports = __webpack_public_path__ + "95d9387b9b8e94df8714a2bc1aae9c76.jpg";